// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiCollectedStatsSeason } from '../models/ApiCollectedStatsSeason';
import { HttpFile } from '../http/http';

export class ApiCollectedStats {
    'boost': number;
    'nextgen_balance': number;
    'gradients_balance': number;
    'memes_balance': number;
    'unique_memes': number;
    'seasons': Array<ApiCollectedStatsSeason>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "boost",
            "baseName": "boost",
            "type": "number",
            "format": "double"
        },
        {
            "name": "nextgen_balance",
            "baseName": "nextgen_balance",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "gradients_balance",
            "baseName": "gradients_balance",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "memes_balance",
            "baseName": "memes_balance",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "unique_memes",
            "baseName": "unique_memes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "seasons",
            "baseName": "seasons",
            "type": "Array<ApiCollectedStatsSeason>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiCollectedStats.attributeTypeMap;
    }

    public constructor() {
    }
}

